import { EntryWithRelated } from '../../../models/inspections'
import { PromptInfoTypeEnum } from '../../../sdk'

export function getAllTechnicianNotes(entry: EntryWithRelated) {
  const notes: string[] = []
  entry.prompts!.forEach((prompt) => {
    if (
      prompt.info!.type === PromptInfoTypeEnum.OpenEnded &&
      prompt.info!.answer
    ) {
      notes.push(prompt.info!.answer)
    }
    if (
      (prompt.info!.type === PromptInfoTypeEnum.MultipleChoice ||
        prompt.info!.type ===
          PromptInfoTypeEnum.MultipleChoiceMultipleSelect) &&
      prompt.info!.technicianNotes
    ) {
      notes.push(prompt.info!.technicianNotes)
    }
  })
  return notes
}
